// @flow
import * as React from 'react';
import styled from 'styled-components';
import RadioInvoice from './RadioInvoice';
import LoadingSpinner from '../../../../common/components/LoadingSpinner';
import RadioCampaignInvoice from '../domain/RadioCampaignInvoice';

const RadioInvoiceWrapper = styled.div`
  padding: 8px;
`;

interface Props {
  t: any;

  fetching: boolean;
  radioInvoices: RadioCampaignInvoice[];
  onBilledChange: (invoice: RadioCampaignInvoice) => (billed: boolean) => mixed;
}

export const LOADING_SPINNER_ID = 'LOADING_SPINNER_ID';
export const NO_INVOICE_MESSAGE_ID = 'NO_INVOICE_MESSAGE_ID';
export const RADIO_INVOICE_WRAPPER_ID = 'RADIO_INVOICE_WRAPPER_ID';

export default function RadioInvoices({ fetching, radioInvoices, onBilledChange, t }: Props) {
  return (
    <React.Fragment>
      { fetching && <LoadingSpinner id={LOADING_SPINNER_ID} />}

      { !fetching && radioInvoices.length === 0 &&
      <div id={NO_INVOICE_MESSAGE_ID}>{t('noInvoiceThisMonth')}</div>
      }

      { !fetching && radioInvoices.map(r =>
        <RadioInvoiceWrapper id={RADIO_INVOICE_WRAPPER_ID} key={r.radio}>
          <RadioInvoice invoice={r} onBilledChange={onBilledChange(r)} />
        </RadioInvoiceWrapper>)
      }
    </React.Fragment>
  );
}



// WEBPACK FOOTER //
// ./src/statsradio/modules/billing/components/RadioInvoices.js